import toastr from "toastr";

const prepareOptions = (Options) => {

    const Defaults = {
        method : 'POST',
        cache  : 'no-cache',
        headers: {
            "Content-type": "application/json",
        },
    }

    const Output = {...Defaults, ...Options.request}
    const isJson = Output.headers['Content-type'] == 'application/json'


    Output.headers.Authorization = `TOKEN: ${window.localStorage.getItem('_tkn')}`
    Output.body = isJson ? JSON.stringify(Options.request.data) : Options.request.data;

    if (Output.method === 'GET') {
        delete Output.body
    }

    if (Output.headers["Content-type"] == null) {
        delete Output.headers["Content-type"];
    }

    return Output;
}


const UseRequest = async (Endpoint, Options) => {

    const Response = await fetch(
        Endpoint, prepareOptions(Options)
    );

    if (
        Response.headers.has('msgType') &&
        Response.headers.get('msgType') != 'off'
    ) {

        const type = Response.headers.get('msgType');
        const title = Response.headers.get('msgTitle');
        const content = Response.headers.get('msgContent');

        toastr[type](content, title, {
            timeOut              : 1500,
            preventDuplicates    : true,
            preventOpenDuplicates: true
        });
    }

    if (Response.status == 401) {
        window.location.href = `${process.env.REACT_APP_BASE_URL}/auth/login`
    }

    return Response
}


const GetEntity = async (id, path) => {
    const response = await (await UseRequest(
        `${process.env.REACT_APP_BASE_API}${path}`,
        {request: {method: 'PUT', data: {limit: 1, offset: 0, _id: id}}}
    )).json();
    return response?.total > 0 ? response.entities[0] : null
}


const GetEntities = async (path, {method, filters, toArray, propLabel, propValue}) => {
    const response = await (await UseRequest(`${process.env.REACT_APP_BASE_API}${path}`,
        {request: {method: method ? method : 'PUT', data: {...{offset: 0}, ...filters}}}
    )).json();



    if (toArray === true && response?.entities?.length > 0) {
        const output = []
        response.entities.map((entity) => {
            output.push({
                value: propValue ? entity[propValue] : entity._id.$oid,
                label: propLabel ? entity[propLabel] : entity.title
            })
        })
        return output
    } else {
        return response.entities
    }
}


export {UseRequest, GetEntities, GetEntity};
